import React, { useEffect } from 'react';
import './NotificationsModal.css';
import NotificationItem from '../Navegación/components/NotificationItem';

const NotificationsModal = ({notifications, onClose, markAllAsRead}) => {
  useEffect(() => {
    if (markAllAsRead) markAllAsRead();
  }, [markAllAsRead]);

  // Ordenar de más reciente a más antigua
  const sorted = [...notifications].sort((a, b) => {
    const dateA = a.timestamp?.toDate ? a.timestamp.toDate() : new Date(a.timestamp || 0);
    const dateB = b.timestamp?.toDate ? b.timestamp.toDate() : new Date(b.timestamp || 0);
    return dateB - dateA;
  });

  return (
    <div className="notifications-modal-overlay" onClick={onClose}>
      <div className="notifications-modal-content" onClick={e => e.stopPropagation()}>
        <h4>Todas las notificaciones</h4>
        <div className="notifications-modal-list">
          <ul>
            {sorted.length === 0 ? (
              <li style={{color: '#888', textAlign: 'center'}}>No tienes notificaciones</li>
            ) : (
              sorted.map((n) => (
                <li key={n.id}>
                  <NotificationItem notification={n} />
                </li>
              ))
            )}
          </ul>
        </div>
        <button onClick={onClose}>Cerrar</button>
      </div>
    </div>
  );
};

export default NotificationsModal;